import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IDocumentModel } from "./Common/types";

interface DocumentsState {
    documents: IDocumentModel[] | null;
}

const initialState: DocumentsState = {
    documents: [],
};

const allDocumentsSlice = createSlice({
    name: "documents",
    initialState,
    reducers: {
        setDocuments: (state, action: PayloadAction<IDocumentModel[]>) => {
            state.documents = action.payload;
        }
    },
});

export const { setDocuments } = allDocumentsSlice.actions;
export default allDocumentsSlice.reducer;